import elderly from "../assets/Images/elderly.png";
import josalukkas from "../assets/Images/josalukkas.png";
import travelExplorer from "../assets/Images/travelExplorer.png";
import photolli from "../assets/Images/photolli.png";

const projectData = [
  {
    title: 'Jos Alukkas E-commerce Platform',
    image: josalukkas,
    tech: ['.NET', 'Angular', 'Python', 'HTML'],
    description:
      'A fully functional and responsive jewelry e-commerce website built for Jos Alukkas. It features secure checkout, real-time product updates, and admin management built using .NET, Angular, and Python for robust performance.',
    url: 'https://www.josalukkasonline.com/',
  },
  {
    title: 'Elderly Care Portal',
    image: elderly,
    tech: ['React', 'MongoDB', 'Stripe'],
    description:
      'A comprehensive health and caregiving portal designed for elderly support. Includes caregiver booking, health dashboards, treatment tracking, and Stripe-based secure payments — all powered by MERN stack.',
    url: 'https://elderly-care-portal.vercel.app/',
  },
  {
    title: 'Travel Explorer',
    image: travelExplorer,
    tech: ['React', 'Tailwind CSS', 'React Router'],
    description:
      'A single-page travel blog and destination discovery app with dynamic routing, tips, gallery, and a modern UI. Developed using React and Tailwind CSS with smooth animations and page transitions.',
    url: 'https://travel-explorer-mu.vercel.app/',
  },
  {
    title: 'Portfolio',
    image: photolli,
    tech: ['React', 'Tailwind CSS', 'Framer Motion'],
    description:
      'My personal portfolio website showcasing projects, skills, and background. Built with Framer Motion for elegant animations, responsive design using Tailwind CSS, and an interactive hero section.',
    url: 'https://tefeena.dev/',
  },
];

export default projectData;
